module.exports = __webpack_public_path__ + "img/wuhan-4.f69913d5.jpg";